const ENTER_KEY_CODE = 13;
const ESC_KEY_CODE = 27;

export function isEnterPressed(e) {
  const code = e?.keyCode ? e?.keyCode : e?.which;
  return !isNaN(code) && parseInt(code) === parseInt(ENTER_KEY_CODE);
}

export function isESCPressed(e) {
  const code = e?.keyCode ? e?.keyCode : e?.which;
  return !isNaN(code) && parseInt(code) === parseInt(ESC_KEY_CODE);
}

export function moveFocusToFirstElementInModal(event, ref) {
  if (event?.key === 'Tab' && ref?.current) {
    const focusableElements = ref?.current?.querySelectorAll(
      'a[href], button, div[role="button"], textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select'
    );

    const firstElement = focusableElements?.[0];
    const lastElement = focusableElements?.[focusableElements?.length - 1];

    if (event?.shiftKey && document?.activeElement === firstElement) {
      // If Shift + Tab and focused on the first element, move focus to the last element
      event?.preventDefault();
      lastElement?.focus();
    } else if (!event?.shiftKey && document?.activeElement === lastElement) {
      // If Tab and focused on the last element, move focus to the first element
      event?.preventDefault();
      firstElement?.focus();
    }
  }
}

export const copyTextToClipboard = (textToCopy) => {
  const textarea = document.createElement('textarea');
  textarea.value = textToCopy;

  // Make the textarea hidden
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';

  // Add the textarea to the document
  document.body.appendChild(textarea);

  // Select the text in the textarea
  textarea.select();

  // Copy the selected text to the clipboard
  document.execCommand('copy');

  // Remove the textarea from the document
  document.body.removeChild(textarea);
};
